import _ from 'lodash';
import alasql from 'alasql';

export function getFinancialReport(data) {
  let member_categories = this.getTeamMemberWithCategory(data);
  // Get unique member category prices (or all if sum)
  let memberCatTotal = member_categories.then(getMemberCatArticleTotal);
  // Get Prices for teams
  let teamsTotal = member_categories.then(getTeamsTotal);
  // Get Prices for Team Members
  let perMemberTeamTotal = member_categories.then(getPerMemberTeamTotal);

  let contenders = getContenders(data);

  let contendersTotal = contenders.then(getContendersTotal);

  return Promise.all([
    memberCatTotal,
    teamsTotal,
    perMemberTeamTotal,
    contendersTotal,
  ]).then(this.combineAndOrder);
}

export function combineAndOrder(data_list) {
	let data = _.flattenDeep(data_list);
	return alasql.promise(`
		SELECT
			AktivPaamelding as [AktivPåmelding],
			KlubbId,
			KlubbNavn,
			GrupperingsType,
			ArtikkelNr,
			ArtikkelNavn,
			Antall,
			TotalPris
		FROM ?
		ORDER BY
			KlubbNavn,
			GrupperingsType,
			ArtikkelNavn
	`, [data]);
}

export function getContenders(data) {
  return alasql.promise(`
    SEARCH / AS @club
      member_registrations / AS @member
      RETURN (
        @club->id AS KlubbId,
        @club->club_name AS KlubbNavn,
        @club->active_reg AS active_reg,
        @club->price_contender AS DeltagerPris,
        @club->contender_article_number AS ArtikkelNr,
        @member->id AS MemberRegId,
        @member->member_id AS MemberId,
        @member->full_name AS FulltNavn
      )
    FROM ?
  `, [data]);
}

export function getContendersTotal(data) {
  return alasql.promise(`
    SELECT
      KlubbId,
      KlubbNavn,
      'Deltagere' AS GrupperingsType,
      active_reg,
      CASE
        WHEN active_reg=true THEN 'Påmeldt'
        WHEN active_reg=false THEN 'Ikke Påmeldt'
      END AS AktivPaamelding,
      ArtikkelNr,
      'Deltager' AS ArtikkelNavn,
      SUM(CAST(DeltagerPris AS NUMBER)) AS TotalPris,
      COUNT(DeltagerPris) AS Antall
    FROM ?
    GROUP BY
      KlubbId,
      KlubbNavn,
      GrupperingsType,
      active_reg,
      ArtikkelNr,
      ArtikkelNavn
  `, [data]);
}

export function getTeamMemberWithCategory(data) {
  return alasql.promise(`
    SEARCH / AS @club
      EX(includeEmptyArray(teams)) / AS @team
      EX(includeEmptyArray(members)) / AS @member
      EX(includeEmptyArray(categories)) / as @category
      RETURN (
        @category->id AS KategoriId,
        @club->id AS KlubbId,
        @club->club_name AS KlubbNavn,
        @club->active_reg AS active_reg,
        @team->name AS GruppeNavn,
        @team->id AS GruppeId,
        @team->team_category_name AS GruppeKategori,
        @team->team_article_number AS GruppeKatArtikkelNr,
        @team->team_price AS GruppeKategoriPris,
        @team->price_per_member AS PrisPerMedlem,
        @team->member_article_number AS PerMedlemArtikkelNr,
        @team->team_type_name AS GrupperingsType,
        @team->price_scheme AS PrisSkjema,
        @member->member_id AS MedlemsId,
        @member->first_name AS Fornavn,
        @member->last_name AS  Etternavn,
        @category->name AS KategoriNavn,
        @category->price AS KategoriPris,
        @category->priority AS Prioritet,
        @category->article_number AS KategoriArtikkelNr
      )
    FROM ?
  `, [data]);
}

export function getMemberCatArticleTotal(team_members_with_cat) {
  return alasql.promise(`
    SELECT
      uniqueIfSum,
			AktivPaamelding,
      KlubbId,
      KlubbNavn,
      GrupperingsType,
      KategoriArtikkelNr AS ArtikkelNr,
      KategoriNavn as ArtikkelNavn,
      COUNT(MedlemsId) as Antall,
      SUM(KategoriPris) AS TotalPris
    FROM (
      SELECT DISTINCT
				AktivPaamelding,
        uniqueIfSum
        PrisSkjema,
        KlubbId,
        KlubbNavn,
        GrupperingsType,
        PrisSkjema,
        MedlemsId,
        Fornavn,
        Etternavn,
        FIRST(KategoriNavn)  as KategoriNavn,
        FIRST(KategoriPris)  as KategoriPris,
        FIRST(KategoriArtikkelNr) as KategoriArtikkelNr
      FROM (
        SELECT
					CASE
						WHEN active_reg=true THEN 'Påmeldt'
						WHEN active_reg=false THEN 'Ikke Påmeldt'
					END AS AktivPaamelding,
          KategoriId,
          KlubbId,
          KlubbNavn,
          GruppeNavn,
          GrupperingsType,
          PrisSkjema,
          CASE PrisSkjema
            WHEN 'sum' THEN KategoriId
            ELSE '9999999'
          END AS uniqueIfSum,
          MedlemsId,
          Fornavn,
          Etternavn,
          KategoriNavn,
          CAST(KategoriPris AS NUMBER) as KategoriPris,
          CAST(Prioritet AS NUMBER) Prioritet,
          KategoriArtikkelNr
        FROM ? as t2
        ORDER BY
          MedlemsId,
          CASE PrisSkjema
            WHEN 'max' THEN KategoriPris * -1
            WHEN 'min' THEN KategoriPris
          END,
          Prioritet
      ) as t1
      GROUP BY
				AktivPaamelding,
        uniqueIfSum,
        PrisSkjema,
        KlubbId,
        KlubbNavn,
        GrupperingsType,
        PrisSkjema,
        MedlemsId,
        Fornavn,
        Etternavn
    )
		WHERE KategoriPris > 0
    GROUP BY
			AktivPaamelding,
      uniqueIfSum,
      KlubbId,
      KlubbNavn,
      GrupperingsType,
      KategoriArtikkelNr,
      KategoriNavn
  `, [team_members_with_cat]);
}


// PrisPerMedlem,
// PerMedlemArtikkelNr,
export function getTeamsTotal(member_cats) {
	return alasql.promise(`
		SELECT
			'bb' AS uniqueIfSum,
			AktivPaamelding,
			KlubbId,
			KlubbNavn,
			GrupperingsType,
			GruppeKatArtikkelNr AS ArtikkelNr,
			GruppeKategori as ArtikkelNavn,
			COUNT(GruppeKategori) as Antall,
			SUM(GruppeKategoriPris) AS TotalPris
		FROM (
			SELECT DISTINCT
				active_reg,
				CASE
					WHEN active_reg=true THEN 'Påmeldt'
					WHEN active_reg=false THEN 'Ikke Påmeldt'
				END AS AktivPaamelding,
				KlubbId,
				KlubbNavn,
				GrupperingsType,
				GruppeId,
				GruppeKatArtikkelNr,
				GruppeKategori,
				GruppeKategori as ArtikkelNavn,
				CAST(GruppeKategoriPris AS NUMBER) AS GruppeKategoriPris
			FROM ?
			WHERE GruppeKategoriPris > 0
			GROUP BY
				KlubbId,
				active_reg,
				KlubbNavn,
				GruppeId,
				GrupperingsType,
				GruppeKatArtikkelNr,
				GruppeKategori,
				GruppeKategori,
				GruppeKategoriPris
		) as t1
		GROUP BY
			uniqueIfSum,
			AktivPaamelding,
			KlubbId,
			KlubbNavn,
			GrupperingsType,
			GruppeKatArtikkelNr,
			GruppeKategori
	`, [member_cats]);
}

export function getPerMemberTeamTotal(member_cats) {
	return alasql.promise(`
		SELECT
			'bb' AS uniqueIfSum,
			AktivPaamelding,
			KlubbId,
			KlubbNavn,
			GrupperingsType,
			ArtikkelNr,
			ArtikkelNavn,
			COUNT(ArtikkelNavn) as Antall,
			SUM(PrisPerMedlem) AS TotalPris
		FROM (
			SELECT DISTINCT
				active_reg,
				CASE
					WHEN active_reg=true THEN 'Påmeldt'
					WHEN active_reg=false THEN 'Ikke Påmeldt'
				END AS AktivPaamelding,
				MedlemsId,
				KlubbId,
				KlubbNavn,
				GrupperingsType,
				PerMedlemArtikkelNr AS ArtikkelNr,
				CONCAT(GruppeKategori, ' - per medlem totalt') as ArtikkelNavn,
				CAST(PrisPerMedlem AS NUMBER) AS PrisPerMedlem
			FROM ?
			WHERE
				PrisPerMedlem > 0 AND
				MedlemsId IS NOT NULL
			GROUP BY
				active_reg,
				MedlemsId,
				KlubbId,
				KlubbNavn,
				GrupperingsType,
				PerMedlemArtikkelNr,
				GruppeKategori,
				PrisPerMedlem
		) as t1
		GROUP BY
			uniqueIfSum,
			AktivPaamelding,
			KlubbId,
			KlubbNavn,
			GrupperingsType,
			ArtikkelNr,
			ArtikkelNavn
	`, [member_cats]);
}



/** WEBPACK FOOTER **
 ** ./src/containers/events/reports/sql/financial.js
 **/